export default __webpack_public_path__ + "static/media/Substrates-Section-Training.fa5071a5.jpg";